module.exports = __webpack_public_path__ + "static/media/TenderCorrigendum_housekeeping.48980661.pdf";